// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"183224c0","396":"0e0940b2","455":"e852a8ee","804":"7af1745a","977":"00bf0965"}[chunkId] + ".chunk.js";
};